import { render, staticRenderFns } from "./BaseFileName.vue?vue&type=template&id=607c4adb&scoped=true&"
import script from "./BaseFileName.vue?vue&type=script&lang=js&"
export * from "./BaseFileName.vue?vue&type=script&lang=js&"
import style0 from "./BaseFileName.vue?vue&type=style&index=0&id=607c4adb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607c4adb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('607c4adb')) {
      api.createRecord('607c4adb', component.options)
    } else {
      api.reload('607c4adb', component.options)
    }
    module.hot.accept("./BaseFileName.vue?vue&type=template&id=607c4adb&scoped=true&", function () {
      api.rerender('607c4adb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseFileName.vue"
export default component.exports